const Icon = ({ icon, className = '' }) => {
    return (
        <i data-icon={icon} className={className} />
    )
}

export default Icon;